import { render, staticRenderFns } from "./61.vue?vue&type=template&id=ec60722a&scoped=true&"
var script = {}
import style0 from "./61.vue?vue&type=style&index=0&id=ec60722a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec60722a",
  null
  
)

export default component.exports